'use strict';

module.exports = {
    countdown: function() {
        countdown();
    }
};

function countdown() {
    document.querySelectorAll('.product-counter').forEach( function (elem) {
        let endDate = null;
        let isPreOrderCountDown = false;
        if(elem.querySelectorAll('#is-sales-term')[0].value === 'true') {
            // セール期間がある場合だけカウントダウンをする。
            endDate = elem.querySelectorAll('#end-date')[0].value;
        } else if (elem.querySelectorAll('#is-preorder-end-date')[0].value === 'true') {
            endDate = elem.querySelectorAll('#pre-order-end-date')[0].value;
            isPreOrderCountDown = true;
        }
        
        if (endDate) {
            const now = new Date(); // 現在時刻を取得
            const end = new Date(endDate); // 明日の0:00を取得
            const diff = end.getTime() - now.getTime(); // 時間の差を取得（ミリ秒）

            // ミリ秒から単位を修正
            const calcHour = Math.floor(diff / 1000 / 60 / 60);
            const calcMin = Math.floor(diff / 1000 / 60) % 60;
            const calcSec = Math.floor(diff / 1000) % 60;

            // 取得した時間を表示
            var dispDays = Math.floor(calcHour/24);
            var disHour = calcHour%24;

            elem.querySelectorAll('#day')[0].textContent = dispDays;
            elem.querySelectorAll('#hour')[0].textContent = disHour < 10 ? '0' + disHour : disHour;
            elem.querySelectorAll('#min')[0].textContent = calcMin < 10 ? '0' + calcMin : calcMin;
            elem.querySelectorAll('#sec')[0].textContent = calcSec < 10 ? '0' + calcSec : calcSec;

            // 時間差（diff）が0以下（終了時間を過ぎている）場合は、タイマー表示を非表示にする
            if (diff <= 0) {
                $('.time-container').css('display', 'none');
                if (isPreOrderCountDown) {
                    window.location.reload();
                }
            }
        }
    });
}

$(async function () {
    countdown();
    setInterval(countdown,1000);
    if (document.getElementById("countdown-3") !== null) {
        const second = 1000,
            minute = second * 60,
            hour = minute * 60,
            day = hour * 24;

        // Fetch current time
        const response = await fetch('https://worldtimeapi.org/api/timezone/Asia/Tokyo');
        const data = await response.json();
        let now = new Date(data.datetime).getTime();

        let endDate = document.getElementById("end-date").value ||  null;
        const countDown = new Date(endDate).getTime(),
        countInterval = setInterval(function() {
            now += 1000; // increment the "now" time by 1000 milliseconds

            const distance = countDown - now;

            document.getElementById("days-3").innerText = Math.floor(distance / (day));
            document.getElementById("hours-3").innerText = Math.floor((distance % (day)) / (hour));
            document.getElementById("minutes-3").innerText = Math.floor((distance % (hour)) / (minute));
            document.getElementById("seconds-3").innerText = Math.floor((distance % (minute)) / second);

            if (distance < 0) {
                document.getElementById("countdown-3").style.display = "none";
                clearInterval(countInterval);
            }
        }, 1000);
    }
});
